import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  summary: {
    marginBottom: 60,
  },
  gridItem: {
    width: 200,
    padding: "0 5px",
  },
  chip: {
    marginBottom: 11,
  },
});

export default useStyles;
